import BaseService from '@root/core/class/BaseService';

class forwardingService extends BaseService {
  public getInboundList = (
    page: number,
    searchBy?: string,
    search?: string,
    fromDt?: string,
    toDt?: string
  ) => {
    return this.get(
      `/posts/inbound?page=${page}${
        Boolean(searchBy) ? '&searchBy=' + searchBy : '&searchBy='
      }${Boolean(search) ? '&search=' + search : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}`
    );
  };

  public getInboundDetail = (id: string) => {
    return this.get(`/posts/inbound/detail/${id}`);
  };
  public updateStatus = (
    id: string,
    data: { status?: string; cancelStatus?: string }
  ) => {
    return this.put(`/posts/status/${id}`, data);
  };

  public createMessage = (data: {
    postId: number;
    content: string;
    attachment: string[];
  }) => {
    return this.post('/posts/dialogs', data);
  };

  public uploadFile = (files: File[]) => {
    const formData = new FormData();
    files.forEach((file) => {
      formData.append('attachments', file);
      console.log('Appending file:', file.name);
    });

    return this.post('/posts/upload-file', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).catch((error) => {
      if (error.response?.status === 413) {
        alert('용량이 너무 큽니다');
      }
      throw error;
    });
  };

  public updateMessage = (
    id: number,
    data: { content: string; attachment: string[] }
  ) => {
    return this.put(`/posts/dialogs/${id}`, data);
  };

  public getSellerList = (
    page: number,
    searchBy?: string,
    search?: string,
    fromDt?: string,
    toDt?: string
  ) => {
    return this.get(
      `/posts?page=${page}${
        Boolean(searchBy) ? '&searchBy=' + searchBy : '&searchBy='
      }${Boolean(search) ? '&search=' + search : '&search='}${
        Boolean(fromDt) ? '&fromDt=' + fromDt : '&fromDt='
      }${Boolean(toDt) ? '&toDt=' + toDt : '&toDt='}`
    );
  };

  public getSellerDetail = (id: string) => {
    return this.get(`/posts/detail/${id}`);
  };
}

export default new forwardingService('/api/v1/forwarding', true);
